
import _ from 'lodash';

const LocalHostName = [
    "local.refpredictorreact.com"
]

const DevHostname = [
    "192.168.0.41",
    "192.168.0.197",
    "192.168.0.55",
    "192.168.0.102",
    "192.168.0.166",
    "192.168.0.90",
    "192.168.159.249",
    "localhost"
]

const StagingHostname = [
    "www.staging.refsocial.com",
    "www.staging.refsocial.app",
    "www.staging.refleague.app",
    "www.staging.refpay.app" ,
    "staging.refsocial.com",
    "staging.refsocial.app",
    "staging.refleague.app",
    "staging.refpay.app" 
]



const regex = /(192)\.(168)(\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])){2}$/gm
const hostname = window.location.hostname;
const protocol = window.location.protocol;
const origin = window.location.origin;


const localRefpredictorPort = 4444;
const localRefLeaguePort = 4445;
const localRefpayPort = 4446;
const localRefsocialPort = 4447;
const localReflivePort = 4448;


const local = {
    isLOCAL: true,
    lsPrefix: "dev_",
    base_url: "https://local.refpredictorreact.com/",
    MyUrl: origin,
    RefpredictorUrl: `http://localhost:${localRefpredictorPort}/`,
    RefleagueUrl: `http://localhost:${localRefLeaguePort}/`,
    RefsocialUrl: `http://localhost:${localRefsocialPort}/`,
    RefliveUrl: `http://localhost:${localReflivePort}/`,
    RefpayUrl: `http://localhost:${localRefpayPort}/`,
};


const  development= {
    isLOCAL: true,
    lsPrefix: "dev_",
        base_url: "https://refsocial.com/",
    MyUrl: origin,
    RefpredictorUrl: `http://localhost:${localRefpredictorPort}/`,
    RefleagueUrl: `http://localhost:${localRefLeaguePort}/`,
    RefsocialUrl: `http://localhost:${localRefsocialPort}/`,
    RefliveUrl: `http://localhost:${localReflivePort}/`,
    RefpayUrl: `http://localhost:${localRefpayPort}/`,
};


const staging = {
    
    isLOCAL: true,
    lsPrefix: "staging_",
    base_url: "https://staging.refsocial.com/",
    MyUrl: origin,
    RefpredictorUrl:`https://staging.refsocial.com/`,
    RefleagueUrl: `https://staging.refleague.app/`,  
    RefsocialUrl:`https://staging.refsocial.app/`,
    RefliveUrl: `https://staging.reflive.app/`,
    RefpayUrl: `https://staging.refpay.app/`,
};

const production = {
    isLOCAL: false,
    lsPrefix: "ref-vinfotech-new_",
    base_url: "https://refsocial.com/",
    MyUrl: origin,
    RefpredictorUrl:`https://refsocial.com/`,
    RefpayUrl: `https://refpay.app/`,
    RefsocialUrl: `https://refsocial.app/`,
    RefliveUrl: `https://reflive.app/`,
    RefleagueUrl: `https://refleague.app/`,
};


const config = production
// _.includes(LocalHostName, hostname) ? local :
//     _.includes(DevHostname, hostname) ? development :
//         _.includes(StagingHostname, hostname) ? staging :
//             production;

console.log(config, hostname)


export default {
    ...config
};